import _ from 'underscore';
import LazyLoad from 'vanilla-lazyload';
import ScrollManager from 'components/manager/ScrollManager';

const MARGIN_HEIGHT = 1500;

class ImageManager  {

  animating = false;

  start() {

    this.LazyLoader = new LazyLoad({
      elements_selector: '.lazy',
      threshold : MARGIN_HEIGHT
    });

    this.images = [].slice.call(document.querySelectorAll('img.lazy'));
    // this.images = [this.images[0]];
    this.onResize();

    ScrollManager.on('scroll', this.onScroll);

  }

  onScroll = () => {

    if (ScrollManager.animating) return;

    const scrollTop = ScrollManager.currentScroll() - MARGIN_HEIGHT;
    const scrollBottom = window.innerHeight + scrollTop + MARGIN_HEIGHT * 2;

    _.each(this.imageInfos, (img)=> {
      const hidden = img.top > scrollBottom || img.bottom < scrollTop;
      if (img.hidden === hidden ) return;
      // img.el.style.visibility = (img.hidden = hidden) ? 'hidden':'inherit';
      img.el.classList[(img.hidden = hidden) ? 'add':'remove']('hidden');
    });

  };

  storeImagePosition() {
    const scrollTop = ScrollManager.currentScroll();
    this.imageInfos = _.map(this.images, (element) => {
      const rect = element.parentNode.getBoundingClientRect();
      return {
        el : element,
        top : rect.top + scrollTop,
        bottom : rect.bottom + scrollTop,
        height : rect.top - rect.bottom
      }
    });
  }

  onResize = ()=> {
    this.storeImagePosition();
    this.onScroll();
  }

}

export default new ImageManager();



// WEBPACK FOOTER //
// ./src/components/manager/ImageManager.js